// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".upload-dropzone{width:100%;min-height:100px;padding:30px;border:1px dashed #e0edff;border-radius:.2rem;text-align:center;background-color:#fafcff;cursor:pointer}.upload-dropzone .main{font-size:1.2rem}.upload-dropzone.active{border-color:#d0e5ff;background-color:#eff6ff}.upload-dropzone button{white-space:normal}\n", ""]);
// Exports
module.exports = exports;
